/*
* Project: LegalPlace assistant
* File: src/components/popup_preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';

import PreviewRow from './preview_row';
import { lpGetVariableById } from '../logic/re_index';
import { generateId1 } from './utils/misc';
import lpApp from '../app/lp_app';

// idout, template
class PopupPreview extends Component {
  constructor(props) {
    super(props);
    // console.log("Pcreated preview");
    this.state = {};
  }

  componentDidMount() {
    const varM = document.querySelectorAll(`.popupViewer [data-var-id='${this.props.variable}']`);
    const popM = document.querySelectorAll('.popupViewer .page');
    // console.log(popM)
    if (varM && this.refs.popup && this.refs.changeThings && varM.length > 0) {
      // var_.
      // if(var_.getBoundingClientRect().y)
      const keysVarM = Object.keys(varM);
      keysVarM.forEach((keyVar) => {
        /** @type {Element} */
        const variable = varM[keyVar];

        if (variable.offsetTop > (window.oo ? window.oo : 120)) {
          // console.log(this.refs.changeThings)

          popM[keyVar].setAttribute('style', `margin-top: -${variable.offsetTop - 40}px`);
        }
        if (variable.offsetTop < 10) {
          // console.log(this.refs.changeThings)
          // console.log("oups")
          popM[keyVar].setAttribute('style', `margin-top: ${variable.offsetTop + 40}px`);
        }
      }, this);
      // console.log(this.refs.popup.getBoundingClientRect())
    }
  }

  shouldComponentUpdate(nextProps) {
    if ((lpApp.action_tracker.last_action === 'EDIT_VARIABLE_VALUE_') && nextProps.state_must_not_update) {
      if (nextProps.var_val !== nextProps.variable) return false;
      let value = '';
      if (lpGetVariableById(nextProps.variable)) value = `<span class='doc-highlight'>${lpGetVariableById(nextProps.variable).value.replace(/<br>/g, '\n').replace(/</g, '&lt;').replace(/\n/g, '<br>')}</span>`;
      if (document.querySelector(`.popupContent [data-var-id='${nextProps.variable}']`)) {
        const edits = document.querySelectorAll(`.popupContent [data-var-id='${nextProps.variable}']`);// .forEach(idx => idx.innerHTML = value)
        const editsLen = edits.length;
        for (let i = 0; i < editsLen; i += 1) {
          edits[i].innerHTML = value;
        }
      }

      // document.querySelectorAll(".lp-doc [data-var-id='" + nextProps.variable + "']");
      const edits = document.querySelectorAll(`.lp-doc [data-var-id='${nextProps.variable}']`);
      const editsLen = edits.length;
      for (let i = 0; i < editsLen; i += 1) {
        edits[i].innerHTML = value;
      }

      return false;
    }
    return true;
  }

  componentDidUpdate() {
    // hgere we do the thing.
    // console.log(this.props.variable)
    // .map(idx => idx.attributes["data-var-id"])

    if (!this.refs.popup) return;

    // let vars = document.getElementsByClassName("popupViewer");
    // console.log(this.props.list)
    const list = [];
    const thisPopup = this.refs.popup.getBoundingClientRect().y
      || this.refs.popup.getBoundingClientRect().top;

    const spanNodes = this.refs.popup.querySelectorAll('.page > div > span');
    for (let i = 0; i < spanNodes.length; i += 1) {
      const BoundingClientRect = spanNodes[i].getBoundingClientRect();
      list.push(BoundingClientRect.y || BoundingClientRect.top);
    }

    const distanceCropped = Math.min(...list.map(idx => idx - thisPopup));

    if (this.refs.changeThings) {
      if (this.refs.changeThings.querySelector(`[data-var-id='${this.props.variable}']`)) {
        /** @type {Element} */
        const variable = this.refs.changeThings.querySelector(`[data-var-id='${this.props.variable}']`);
        const page = this.refs.changeThings;
        //
        if (page) {
          if (variable.offsetTop > (120)) {
            page.setAttribute('style', `margin-top: -${distanceCropped + variable.offsetTop - window.lfoug}px`);
          } else if (variable.offsetTop < 0) {
            page.setAttribute('style', `margin-top: ${distanceCropped + variable.offsetTop + window.lfoug}px`);
          }
        }
      } else {
        // console.log("l")
      }
    }
    const nbrSys = {};
    // this one must change
    const numbers = document.querySelectorAll('.popupPreviewContainer [num-auto], .popupPreviewContainer [num-auto-pre]');
    // get the numbering system

    // console.log(numbers);
    for (let i = 0; i < numbers.length; i += 1) {
      const v = numbers[i];
      if (v && v.attributes && v.attributes.getNamedItem('num-auto')) {
        nbrSys[v.attributes.getNamedItem('num-auto').value] = 0;
      } else {
        nbrSys[v.attributes.getNamedItem('num-auto-pre').value] = 0;
      }
    }

    Object.keys(numbers).forEach((idx) => {
      const element = numbers[idx];
      if (element && element.attributes && element.attributes.getNamedItem('num-auto')) {
        const counter = element.attributes.getNamedItem('num-auto').value;
        nbrSys[counter] += 1;
        element.innerHTML = nbrSys[counter];
        // test if it's an article
        if (counter === 'articles') {
          // init all them
          Object.keys(nbrSys).forEach((index) => {
            if (index !== 'articles') nbrSys[index] = 0;
          });
        }
      } else if (element && element.attributes) {
        const counter = element.attributes.getNamedItem('num-auto-pre').value;
        element.innerHTML = nbrSys[counter];
      }
    });
  }

  render() {
    return (!this.props.fullWidth && (
    <div style={{display: 'none'}} className="popupPreviewContainer">
      <div className="popupPreview" ref="poop">
        {// (this.props.isShown) &&
          <div className="popupViewer" ref="popup" key={generateId1(4)}>
            <div className="popupContent">
              { ((this.props.var_val && (this.props.var_val === this.props.variable)) || (typeof this.props.var_val === 'undefined'))
                && (
                <div ref="changeThings" className="page">
                  {!lpApp.env.is_mobile && this.props.isShown && (
                  <div>
                    {this.props.list.map(idx => (
                      <PreviewRow
                        key={generateId1(4)}
                        idOut={idx[1]}
                        out={idx[0]}
                        am_popup
                      />))}
                  </div>
                  )}
                </div>
                )
            }
            </div>
          </div>
        }
      </div>
    </div>
    ));
  }
}

const mapStateToProps = (state, ownProps) => {
  const viewId = '';
  let isShown = false;
  const hide = state.contract.fullWidth;
  if (lpApp.action_tracker.last_action === 'EDIT_VARIABLE_VALUE_' || (state.input_context.variable !== ownProps.var_val)) {
    return {
      state_must_not_update: true,
      idOption: state.input_context.option,
      variable: state.input_context.variable,
      value: lpGetVariableById(state.input_context.variable),
    };
  }
  let lst = [];
  if (state.input_context.variable !== '') {
    const vid = state.input_context.variable;
    if (state.input_context.variable === ownProps.var_val) {
      lst = lpApp.ops.content.getOutputFroPreview(vid);
    }
    if (lst.length > 0) isShown = true;
  }

  // this line i for debugging
  // console.log([the_before, the_output, the_next])
  // console.log([the_before, the_output, the_next])
  return {
    template: viewId,
    idOption: state.input_context.option,
    isShown,
    variable: state.input_context.variable,
    list: lst,
    fullWidth: hide,
  };
};

const LpPopupPreview = connect(mapStateToProps)(PopupPreview);

export default LpPopupPreview;



// WEBPACK FOOTER //
// ./src/components/popup_preview.js